/* Barefoot Botanicals, shared front-end behaviour.
 Safe to load once; guards against double-init in the theme editor. */
(function () {
 function initReveal(root) {
 var els = (root || document).querySelectorAll('.bb .reveal:not([data-bb-observed])');
 if (!('IntersectionObserver' in window)) {
 els.forEach(function (el) { el.classList.add('in'); });
 return;
 }
 var io = new IntersectionObserver(function (entries) {
 entries.forEach(function (e) {
 if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
 });
 }, { threshold: 0.12 });
 els.forEach(function (el) { el.setAttribute('data-bb-observed', '1'); io.observe(el); });
 }

 function initAddFeedback(root) {
 (root || document).querySelectorAll('.bb form[data-bb-add]:not([data-bb-bound])').forEach(function (form) {
 form.setAttribute('data-bb-bound', '1');
 form.addEventListener('submit', function () {
 var btn = form.querySelector('button[type="submit"], .add');
 if (!btn || btn.disabled) return;
 btn.textContent = 'Adding…';
 // Do not disable here — some browsers cancel native submit if the button is disabled mid-submit.
 });
 });
 (root || document).querySelectorAll('.bb .add:not([data-bb-bound]):not(form .add)').forEach(function (btn) {
 if (btn.closest('form')) return;
 btn.setAttribute('data-bb-bound', '1');
 btn.addEventListener('click', function () {
 if (btn.disabled) return;
 var original = btn.textContent;
 btn.textContent = 'Added ✓';
 btn.style.background = 'var(--bb-calendula)';
 btn.style.borderColor = 'var(--bb-calendula)';
 btn.style.color = 'var(--bb-ink-deep)';
 setTimeout(function () { btn.textContent = original; btn.style.background = ''; btn.style.borderColor = ''; btn.style.color = ''; }, 1400);
 });
 });
 }

 function initSmoothScroll(root) {
 var scope = root || document;
 var header = document.querySelector('.bb-header');
 var links = scope.querySelectorAll('a[href^="#"]:not([data-bb-scroll-bound])');
 links.forEach(function (link) {
 var href = link.getAttribute('href');
 if (!href || href === '#') return;
 var target = document.querySelector(href);
 if (!target) return;
 link.setAttribute('data-bb-scroll-bound', '1');
 link.addEventListener('click', function (e) {
 e.preventDefault();
 var offset = (header ? header.offsetHeight : 0) + 12;
 var top = target.getBoundingClientRect().top + window.scrollY - offset;
 var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
 window.scrollTo({ top: Math.max(0, top), behavior: reduced ? 'auto' : 'smooth' });
 history.pushState(null, '', href);
 var nav = document.querySelector('[data-bb-nav-links]');
 if (nav) {
  nav.classList.remove('open');
  document.documentElement.classList.remove('bb-nav-open');
  document.body.classList.remove('bb-nav-open');
  var toggle = document.querySelector('[data-bb-nav-toggle]');
  if (toggle) toggle.setAttribute('aria-expanded', 'false');
 }
 });
 });
 }

 function initLeadFormSubmitFeedback(root) {
  (root || document).querySelectorAll('form.bb-lead-form:not([data-bb-submit-bound])').forEach(function (form) {
   form.setAttribute('data-bb-submit-bound', '1');
   form.addEventListener('submit', function () {
    var btn = form.querySelector('button[type="submit"]');
    if (!btn || btn.disabled) return;
    btn.disabled = true;
    btn.textContent = 'Sending…';
    if (form.id) {
     try { sessionStorage.setItem('bb_lead_pending', form.id); } catch (err) {}
    }
   });
  });
 }

 function scrollToSection(sectionId) {
  var target = document.getElementById(sectionId);
  if (!target) return;
  var header = document.querySelector('.bb-header');
  var offset = (header ? header.offsetHeight : 0) + 12;
  var top = target.getBoundingClientRect().top + window.scrollY - offset;
  window.scrollTo({ top: Math.max(0, top), behavior: 'auto' });
 }

 function cleanLeadReturnParam(paramName) {
  var params = new URLSearchParams(window.location.search);
  if (!params.has(paramName)) return;
  params.delete(paramName);
  var query = params.toString();
  var nextUrl = window.location.pathname + (query ? '?' + query : '') + window.location.hash;
  history.replaceState(null, '', nextUrl);
 }

 function leadReturnHash() {
  return (window.location.hash || '').replace(/^#/, '');
 }

 var LEAD_RETURN_FORMS = {
  GuideLeadBanner: 'guide',
  GuideLeadPopup: 'guide',
  CourseWaitlistForm: 'course'
 };

 function markLeadFormPosted(form) {
  if (!form || !form.id) return;
  form.classList.add('bb-lead-posted');
  try { sessionStorage.removeItem('bb_lead_pending'); } catch (err) {}
 }

 function applyLeadFormReturn(formId) {
  var form = document.getElementById(formId);
  if (!form) return false;
  markLeadFormPosted(form);
  return true;
 }

 function isGuideLeadReturn(params) {
  params = params || new URLSearchParams(window.location.search);
  if (params.get('guide_lead') === 'success') return true;
  var hash = leadReturnHash();
  if (hash === 'guide') return true;
  if (hash !== 'GuideLeadBanner' && hash !== 'GuideLeadPopup') return false;
  if (params.get('customer_posted') === 'true') return true;
  try {
   if (sessionStorage.getItem('bb_lead_pending') === hash) return true;
  } catch (err) {}
  return true;
 }

 function isCourseWaitlistReturn(params) {
  params = params || new URLSearchParams(window.location.search);
  if (params.get('course_waitlist') === 'success') return true;
  var hash = leadReturnHash();
  // Do not treat #course (section nav) as a waitlist return — only the form hash.
  if (hash !== 'CourseWaitlistForm') return false;
  if (params.get('customer_posted') === 'true') return true;
  try {
   if (sessionStorage.getItem('bb_lead_pending') === hash) return true;
  } catch (err) {}
  return true;
 }

 function ensureGuideLeadSuccess() {
  if (!isGuideLeadReturn()) return;
  var hash = leadReturnHash();
  if (hash === 'GuideLeadBanner' || hash === 'GuideLeadPopup') {
   applyLeadFormReturn(hash);
   return;
  }
  applyLeadFormReturn('GuideLeadBanner');
 }

 function ensureCourseWaitlistSuccess() {
  if (!isCourseWaitlistReturn()) return;
  applyLeadFormReturn('CourseWaitlistForm');
 }

 function openPostedLeadPopup(popupId) {
  var popup = document.getElementById(popupId);
  if (!popup) return;
  var success = popup.querySelector('.bb-lead-form.bb-lead-posted .bb-lead-success-on-post')
   || popup.querySelector('.bb-lead-form:target .bb-lead-success-on-post')
   || popup.querySelector('#CourseWaitlistSuccess')
   || popup.querySelector('.bb-lead-posted-success:not(.bb-lead-success-on-post)');
  if (!success) return;
  popup.hidden = false;
  popup.classList.add('is-open');
  popup.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
  if (typeof success.focus === 'function') {
   try { success.focus({ preventScroll: true }); } catch (err) { success.focus(); }
  }
 }

 function initLeadFormReturns() {
  var params = new URLSearchParams(window.location.search);
  var hash = leadReturnHash();
  var guideSuccess = isGuideLeadReturn(params);
  var courseSuccess = isCourseWaitlistReturn(params);

  if (guideSuccess && courseSuccess) {
   courseSuccess = hash === 'CourseWaitlistForm';
   guideSuccess = !courseSuccess;
  }

  if (guideSuccess) {
   ensureGuideLeadSuccess();
   try { localStorage.setItem('bb_guide_popup_seen', '1'); } catch (err) {}
   if (hash === 'GuideLeadPopup') openPostedLeadPopup('guidePopup');
   scrollToSection('guide');
   var bannerSuccess = document.querySelector('#GuideLeadBanner.bb-lead-posted .bb-lead-success-on-post, #GuideLeadBannerSuccess');
   if (bannerSuccess && typeof bannerSuccess.focus === 'function') {
    try { bannerSuccess.focus({ preventScroll: true }); } catch (err) { bannerSuccess.focus(); }
   }
   if (params.get('guide_lead') === 'success') cleanLeadReturnParam('guide_lead');
   if (params.get('customer_posted') === 'true') cleanLeadReturnParam('customer_posted');
  }

  if (courseSuccess) {
   ensureCourseWaitlistSuccess();
   openPostedLeadPopup('coursePopup');
   scrollToSection('course');
   if (params.get('course_waitlist') === 'success') cleanLeadReturnParam('course_waitlist');
   if (params.get('customer_posted') === 'true') cleanLeadReturnParam('customer_posted');
  }
 }

 function guideLeadAlreadyCaptured() {
  if (document.getElementById('GuideLeadBannerSuccess')) return true;
  if (document.querySelector('#GuideLeadBanner.bb-lead-posted, #GuideLeadPopup.bb-lead-posted')) return true;
  return isGuideLeadReturn();
 }

 function closeGuidePopup() {
 var popup = document.getElementById('guidePopup');
 if (!popup) return;
 popup.classList.remove('is-open');
 popup.hidden = true;
 popup.setAttribute('aria-hidden', 'true');
 document.body.style.overflow = '';
 }

 function openGuidePopup() {
 var popup = document.getElementById('guidePopup');
 if (!popup || popup.getAttribute('data-bb-opened') === '1') return;
 if (guideLeadAlreadyCaptured()) return;
 try {
 if (localStorage.getItem('bb_guide_popup_seen')) return;
 } catch (e) {}
 popup.setAttribute('data-bb-opened', '1');
 popup.hidden = false;
 popup.classList.add('is-open');
 popup.setAttribute('aria-hidden', 'false');
 document.body.style.overflow = 'hidden';
 try { localStorage.setItem('bb_guide_popup_seen', '1'); } catch (e) {}
 }

 function initGuidePopup(root) {
 var scope = root || document;
 var section = scope.querySelector ? scope.querySelector('[data-guide-popup]') : null;
 if (!section && scope !== document) return;
 if (!section) section = document.querySelector('[data-guide-popup]');
 var popup = document.getElementById('guidePopup');
 if (!section || !popup || popup.getAttribute('data-bb-popup-bound') === '1') return;
 popup.setAttribute('data-bb-popup-bound', '1');

 var delaySec = parseInt(section.getAttribute('data-guide-delay') || '20', 10);
 var scrollPct = parseInt(section.getAttribute('data-guide-scroll') || '40', 10);

 setTimeout(openGuidePopup, Math.max(0, delaySec) * 1000);

 window.addEventListener('scroll', function () {
 var doc = document.documentElement;
 var max = doc.scrollHeight - window.innerHeight;
 if (max <= 0) return;
 if ((window.scrollY / max) * 100 >= scrollPct) openGuidePopup();
 }, { passive: true });

 popup.querySelectorAll('[data-guide-popup-close]').forEach(function (el) {
 el.addEventListener('click', closeGuidePopup);
 });
 document.addEventListener('keydown', function (e) {
 if (e.key === 'Escape') closeGuidePopup();
 });
 }

 function scrollToContactReturn(focusSuccess) {
 var target = document.getElementById('ContactFormSuccess') || document.getElementById('contact');
 if (!target) return;
 var header = document.querySelector('.bb-header');
 var offset = (header ? header.offsetHeight : 0) + 12;
 var top = target.getBoundingClientRect().top + window.scrollY - offset;
 window.scrollTo({ top: Math.max(0, top), behavior: 'auto' });
 if (focusSuccess && target.id === 'ContactFormSuccess' && typeof target.focus === 'function') {
 try { target.focus({ preventScroll: true }); } catch (err) { target.focus(); }
 }
 }

 function initContactReturn() {
 var params = new URLSearchParams(window.location.search);
 var hash = window.location.hash;
 var posted = params.get('contact_posted') === 'true' || hash === '#contact';
 if (!posted) return;

 // Heavy media above the form can shift layout; re-scroll after load.
 scrollToContactReturn(true);
 window.setTimeout(function () { scrollToContactReturn(false); }, 250);
 window.setTimeout(function () { scrollToContactReturn(true); }, 900);
 if (document.readyState !== 'complete') {
 window.addEventListener('load', function () {
 scrollToContactReturn(true);
 window.setTimeout(function () { scrollToContactReturn(false); }, 200);
 });
 }
 }

 function boot(root) {
 initReveal(root);
 initAddFeedback(root);
 initSmoothScroll(root);
 initLeadFormSubmitFeedback(root);
 initTestiReadMore(root);
 initCalendlyPopup(root);
 initGuidePopup(root);
 initCourseWaitlistPopup(root);
 if (!root || root === document) {
  initContactReturn();
  initLeadFormReturns();
 }
 }

 function initTestiReadMore(root) {
 var cards = (root || document).querySelectorAll('.bb-testi-card:not([data-bb-testi-bound])');
 cards.forEach(function (card) {
 card.setAttribute('data-bb-testi-bound', '1');
 var quote = card.querySelector('.bb-testi-quote');
 var btn = card.querySelector('.bb-testi-read-more');
 if (!quote || !btn) return;

 function sync() {
 if (quote.classList.contains('is-expanded')) return;
 btn.hidden = quote.scrollHeight <= quote.clientHeight + 1;
 }

 btn.addEventListener('click', function () {
 var expanded = quote.classList.toggle('is-expanded');
 btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
 btn.textContent = expanded ? 'Show less' : 'Read more';
 if (!expanded) sync();
 });

 sync();
 });
 }

 function initCalendlyPopup(root) {
  (root || document).querySelectorAll('[data-calendly-popup]:not([data-bb-calendly-bound])').forEach(function (btn) {
   btn.setAttribute('data-bb-calendly-bound', '1');
   btn.addEventListener('click', function (e) {
    e.preventDefault();
    var url = btn.getAttribute('href');
    if (!url) return;
    if (window.Calendly && typeof window.Calendly.initPopupWidget === 'function') {
     window.Calendly.initPopupWidget({ url: url });
    } else {
     window.open(url, '_blank', 'noopener');
    }
   });
  });
 }

 function closeCoursePopup() {
  var popup = document.getElementById('coursePopup');
  if (!popup) return;
  popup.classList.remove('is-open');
  popup.hidden = true;
  popup.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
 }

 function openCoursePopup() {
  var popup = document.getElementById('coursePopup');
  if (!popup) return;
  popup.hidden = false;
  popup.classList.add('is-open');
  popup.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
  var email = popup.querySelector('input[type="email"]');
  if (email) window.setTimeout(function () { email.focus(); }, 100);
 }

 function initCourseWaitlistPopup(root) {
  var scope = root || document;
  var popup = document.getElementById('coursePopup');
  if (!popup || popup.getAttribute('data-bb-popup-bound') === '1') return;
  popup.setAttribute('data-bb-popup-bound', '1');

  scope.querySelectorAll('[data-course-waitlist]:not([data-bb-course-bound])').forEach(function (btn) {
   btn.setAttribute('data-bb-course-bound', '1');
   btn.addEventListener('click', function (e) {
    e.preventDefault();
    openCoursePopup();
    var nav = document.querySelector('[data-bb-nav-links]');
    if (nav) {
     nav.classList.remove('open');
     document.documentElement.classList.remove('bb-nav-open');
     document.body.classList.remove('bb-nav-open');
     var toggle = document.querySelector('[data-bb-nav-toggle]');
     if (toggle) toggle.setAttribute('aria-expanded', 'false');
    }
   });
  });

  popup.querySelectorAll('[data-course-popup-close]').forEach(function (el) {
   el.addEventListener('click', closeCoursePopup);
  });
  document.addEventListener('keydown', function (e) {
   if (e.key === 'Escape' && popup.classList.contains('is-open')) closeCoursePopup();
  });
 }

 if (document.readyState !== 'loading') boot(document);
 else document.addEventListener('DOMContentLoaded', function () { boot(document); });

 // Re-init when sections are added/edited in the Shopify theme editor.
 document.addEventListener('shopify:section:load', function (e) { boot(e.target); });

 var testiResizeTimer;
 window.addEventListener('resize', function () {
 clearTimeout(testiResizeTimer);
 testiResizeTimer = setTimeout(function () {
 document.querySelectorAll('.bb-testi-card').forEach(function (card) {
 var quote = card.querySelector('.bb-testi-quote');
 var btn = card.querySelector('.bb-testi-read-more');
 if (!quote || !btn || quote.classList.contains('is-expanded')) return;
 btn.hidden = quote.scrollHeight <= quote.clientHeight + 1;
 });
 }, 150);
 });
})();
